import { __extends } from "tslib";
import { deserializeAws_json1_1StopTrainingEntityRecognizerCommand, serializeAws_json1_1StopTrainingEntityRecognizerCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StopTrainingEntityRecognizerCommand = /** @class */ (function (_super) {
    __extends(StopTrainingEntityRecognizerCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StopTrainingEntityRecognizerCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StopTrainingEntityRecognizerCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StopTrainingEntityRecognizerCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StopTrainingEntityRecognizerCommand(input, context);
    };
    StopTrainingEntityRecognizerCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StopTrainingEntityRecognizerCommand(output, context);
    };
    return StopTrainingEntityRecognizerCommand;
}($Command));
export { StopTrainingEntityRecognizerCommand };
//# sourceMappingURL=StopTrainingEntityRecognizerCommand.js.map